import { APP_LINKS } from '../../data/siteContent';

interface BadgeProps {
  className?: string;
  /** true = ring glow + scale-up, false = dimmed, undefined = neutral */
  highlighted?: boolean;
}

export function AppStoreBadge({ className = 'h-10', highlighted }: BadgeProps) {
  return (
    <a
      href={APP_LINKS.appStore}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download on the App Store"
      className={`inline-block transition-all duration-300 ${
        highlighted === true
          ? 'ring-2 ring-primary ring-offset-2 rounded-lg scale-105 shadow-lg shadow-primary/20'
          : highlighted === false
            ? 'opacity-60'
            : ''
      }`}
    >
      <svg className={className} viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="40" rx="5" fill="#000" />
        <text x="42" y="12" fill="#fff" fontSize="5.5" fontFamily="system-ui, sans-serif">
          Download on the
        </text>
        <text x="42" y="24" fill="#fff" fontSize="11" fontWeight="600" fontFamily="system-ui, sans-serif">
          App Store
        </text>
        <g transform="translate(10, 6)" fill="#fff">
          <path d="M18.9 14.2c0-3.2 2.6-4.7 2.7-4.8-1.5-2.2-3.8-2.5-4.6-2.5-2-.2-3.8 1.2-4.8 1.2s-2.5-1.1-4.1-1.1c-2.1 0-4.1 1.2-5.2 3.1-2.2 3.8-.6 9.5 1.6 12.6 1.1 1.5 2.3 3.2 3.9 3.1 1.6-.1 2.2-1 4.1-1s2.4 1 4.1 1 2.7-1.5 3.8-3.1c1.2-1.8 1.7-3.5 1.7-3.6 0 0-3.2-1.2-3.2-4.9zM15.8 4.9c.9-1.1 1.5-2.6 1.3-4.1-1.3.1-2.8.9-3.7 1.9-.8.9-1.5 2.4-1.3 3.8 1.4.1 2.8-.7 3.7-1.6z" transform="scale(0.8)" />
        </g>
      </svg>
    </a>
  );
}

export function GooglePlayBadge({ className = 'h-10', highlighted }: BadgeProps) {
  return (
    <a
      href={APP_LINKS.googlePlay}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get it on Google Play"
      className={`inline-block transition-all duration-300 ${
        highlighted === true
          ? 'ring-2 ring-primary ring-offset-2 rounded-lg scale-105 shadow-lg shadow-primary/20'
          : highlighted === false
            ? 'opacity-60'
            : ''
      }`}
    >
      <svg className={className} viewBox="0 0 135 40" xmlns="http://www.w3.org/2000/svg">
        <rect width="135" height="40" rx="5" fill="#000" />
        <text x="47" y="12" fill="#fff" fontSize="5" fontFamily="system-ui, sans-serif" letterSpacing="0.5">
          GET IT ON
        </text>
        <text x="47" y="25" fill="#fff" fontSize="11" fontWeight="500" fontFamily="system-ui, sans-serif">
          Google Play
        </text>
        <g transform="translate(9, 5)">
          <path d="M5 2l13 8-13 8V2z" fill="#fff" opacity="0.9" />
          <path d="M5 2l8 8-8 8V2z" fill="#4285F4" />
          <path d="M5 2l13 8-5 3L5 6V2z" fill="#EA4335" />
          <path d="M5 18l8-5 5 3-13 8v-6z" fill="#34A853" />
          <path d="M13 10l5-3v6l-5 3v-6z" fill="#FBBC04" />
        </g>
      </svg>
    </a>
  );
}
